<template>
    <section class="content">
        <div class="row">

        <impressao :filtro="filtro" :show="showImpressao" @close="()=> { showImpressao = false }" ref='impressao'></impressao>

            <div class="col-md-12">
                <alert></alert> <!-- rederizando componente alert -->
                <div class="box box-solid">
                    <div class="box-header with-border">
                        <h3 class="box-title"><b>Relatório de Fechamento</b></h3> 
                    </div>

                    <div class="box-body">
                        <div class="row">
                            <div class="col-sm-3">
                                <div :class="{'form-group': true }">
                                    <label for="nome">Dia do Fechamento</label>
                                    <select class="form-control" name="nome" v-model="filtro.diaFechamento">
                                        <option value="">--Selecione--</option>
                                        <option value="03">03</option>
                                        <option value="10">10</option>
                                        <option value="18">18</option>
                                        <option value="25">25</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3">
                             <label>Mês/Ano</label>
                             <datepicker :language="ptBR" minimum-view="month" format="MMM/yyyy" input-class="form-control" v-model="datepickerMes" name="competencia"></datepicker>
                         </div> 

                         <div class="col-md-3">
                          <button @click="getFechamento()" class='btn btn-warning' style="margin-top: 1.8em;"><i class='fa fa-search'></i></button>
                      </div>  

                  </div>
                  <div class="row" style="margin-top:15px">
                    <div class="col-sm-12 table-responsive">
                        <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped">
                            <thead>
                                <tr role="row">
                                    <th style="width: 55%">Fantasia</th>
                                    <th style="width: 15%;">C. Restritiva</th>
                                    <th style="width: 15%;">C. Analítica</th>
                                    <th style="width: 15%;">Total</th>
                                    <th style="width: 10%;">Ação</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="even" role="row" v-for="item in apiData.data">
                                    <td>{{ item.fantasia }}</td>
                                    <td>R$ {{ number_format(item.total_restritiva,2,',','.') }}</td>
                                    <td>R$ {{ number_format(item.total_analitica,2,',','.') }}</td>
                                    <td>R$ {{ number_format(item.total,2,',','.') }}</td>
                                    <td>
                                        <a title='Imprimir' href="javascript:void(0)" @click="imprimir(item.id)"><i class="fa fa-fw fa-print"></i></a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div class="row">
                            <div class='col-sm-5'>
                                Mostrando {{ this.apiData.from }} até {{ this.apiData.to }} de {{ this.apiData.total }} registros encontrados.
                            </div>
                            <div class='col-sm-7' style="text-align:right">
                                <laravue-pagination :data="apiData" v-on:pagination-change-page="getFechamento">
                                    <span slot="prev-nav">&lt; Anterior</span>
                                    <span slot="next-nav">Próximo &gt;</span>
                                </laravue-pagination>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div> <!-- /.box-body -->
        </div> <!-- /.box -->
    </div> <!-- /.col-md-12 -->
</div> <!-- /.row -->
</section>
</template>
<script>
    import axios from 'axios' // Cliente para requisição http
    import Alert from '../Alert' // Importando componente alert 
    import Datepicker from 'vuejs-datepicker'
    import {en, ptBR} from 'vuejs-datepicker/dist/locale'

    import Impressao from './Impressao'
    
    export default {

        data() {
            return {
                showImpressao: false,
                filtro: {
                    diaFechamento: '',
                    mesAno: '',
                    empresaId: null
                },
                apiData: {},
                datepickerMes: null,
                en:en,
                ptBR: ptBR,
            }
        },

        mounted () {

        },

        methods: {
            imprimir(id) {
                this.filtro.empresaId = id;
                this.showImpressao = true;
            },
            getFechamento(page) {
                if (typeof page === 'undefined') {
                    page = 1;
                }
                this.$store.commit('TOGGLE_LOADING');
                axios.get(`${this.$store.state.serverURI}/api/financeiro/getFechamento/${this.filtro.diaFechamento}/${this.filtro.mesAno}` + '/?page=' + page, this.$store.getters.getHeaderAuth)
                .then(response => {

                    this.apiData = response.data;
                    this.$store.commit('TOGGLE_LOADING');
                }).catch((error) => { this.$store.commit('throwException', error); });
            },
            number_format(number, decimals, decPoint, thousandsSep) {
                number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
                var n = !isFinite(+number) ? 0 : +number;
                var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
                var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep;
                var dec = (typeof decPoint === 'undefined') ? '.' : decPoint;
                var s = '';
                var toFixedFix = function (n, prec) {
                    var k = Math.pow(10, prec);
                    return '' + Math.round(n * k) / k;
                };
                s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
                if (s[0].length > 3) {
                    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
                }
                if ((s[1] || '').length < prec) {
                    s[1] = s[1] || '';
                    s[1] += new Array(prec - s[1].length + 1).join('0');
                }
                return s.join(dec);
            },
        },
        watch: {
            page: function (val) {
                this.getFechamento();
            },
            datepickerMes: function(val) {
                this.filtro.mesAno = val.toJSON().substring(0, 7);
            }
        },

        components: {
            Alert,
            Datepicker,
            Impressao
        }
    }
</script>
<style>
    .box.box-solid>.box-header .btn.btn-default {
        background-color: #f4f4f4;
        color: #444;
        border-color: #ddd;
    }

    .box.box-solid>.box-header .btn.btn-default:hover {
     color: #333;
     background-color: #d4d4d4;
     border-color: #8c8c8c;
 }


</style>


// WEBPACK FOOTER //
// List.vue?7c04f9c6